type BonusStatisticsUrlConfigType = {
  search?: string | null;
  amount?: string;
  transactionType?: string[];
  dateAfter?: string | null;
  dateBefore?: string | null;
  activityIds?: number[];
  activityId?: string | null;
  citiesIds?: number[];
  status?: string;
  size?: number | null;
  page?: number | null;
  pagination?: boolean;
};

export const bonusStatisticsUrlConfig = ({
  search,
  amount,
  transactionType,
  status,
  dateAfter,
  dateBefore,
  activityIds,
  activityId,
  citiesIds,
  size,
  page,
  pagination = true,
}: BonusStatisticsUrlConfigType): string => {
  const searchParams = search ? `&search_query=${search}` : '';
  const amountParams = amount ? `&${amount}` : '';
  const dateBeforeParams = dateBefore ? `&created_before=${dateBefore}` : '';
  const dateAfterParams = dateAfter ? `&created_after=${dateAfter}` : '';
  const activityIdParams = activityId ? `&activity_id=${activityId}` : '';
  const activityIdsParams =
    activityIds && activityIds.length > 0 ? `&activity_ids=${activityIds.join('&activity_ids=')}` : '';
  const citiesIdsParams =
    citiesIds && citiesIds.length > 0 ? `&sales_point_city_ids=${citiesIds.join('&sales_point_city_ids=')}` : '';
  const transactionTypeParams =
    transactionType && transactionType.length > 0
      ? `&transaction_types=${transactionType.join('&transaction_types=')}`
      : '';
  const statusParams = status ? `&transaction_status=${status}` : '';
  const sizeParams = size && pagination ? `&size=${size}` : '';
  const pageParams = page && pagination ? `&page=${page}` : '';

  return `/wallet/admin/transactions/?wallet_app_type=b2b${sizeParams}${pageParams}${amountParams}${searchParams}${dateAfterParams}${dateBeforeParams}${activityIdsParams}${transactionTypeParams}${statusParams}${citiesIdsParams}${activityIdParams}&wallet_app_type=b2b`;
};
